import CustomFormTranslations from "../en/custom-translations.js";
export default CustomFormTranslations;